import {
  CalendarIcon,
  CashIcon,
  CutleryIcon,
  GraduationCapIcon,
  HandHeartIcon,
  IdCardIcon,
  TrendUpIcon,
} from '@/components/icons';
import type { ElementType } from 'react';

export interface Vacancy {
  id: string;
  title: string;
  salary: string;
  schedule: string;
  type: string;
  image: string;
  duties: string[];
  requirements: string[];
}

export interface Perk {
  icon: ElementType;
  title: string;
  desc: string;
}

const CDN = 'https://cdn.aziatochka.ru/aziatochka';

export const VACANCIES: Vacancy[] = [
  {
    id: 'admin',
    title: 'Администратор службы доставки',
    salary: 'от 3 200₽ до 4 500₽ смена',
    schedule: '2/2',
    type: 'Полная занятость',
    image: `${CDN}/vacansii%20/admin.webp`,
    duties: [
      'Координация работы курьеров',
      'Контроль качества и скорости доставки',
      'Работа с клиентами',
    ],
    requirements: [
      'Опыт работы в общепите от 1 года',
      'Лидерские качества',
      'Стрессоустойчивость',
    ],
  },
  {
    id: 'operator',
    title: 'Оператор call-центра (удалённо)',
    salary: 'от 2 000₽ до 3 500₽ смена',
    schedule: '2/2, 5/2, 6/1',
    type: 'Удалённая работа',
    image: `${CDN}/vacansii%20/operator.webp`,
    duties: [
      'Приём и обработка заказов',
      'Консультирование клиентов',
      'Работа с внутренней CRM-системой',
    ],
    requirements: [
      'Грамотная речь',
      'Стрессоустойчивость',
      'Без опыта — обучим',
    ],
  },
  {
    id: 'sushist',
    title: 'Повар-сушист',
    salary: 'от 4 000₽ до 5 000₽ смена',
    schedule: '5/2, 6/1, 2/2',
    type: 'Полная занятость',
    image: `${CDN}/vacansii%20/suhist.webp`,
    duties: [
      'Приготовление блюд японской кухни',
      'Контроль качества продукции',
      'Соблюдение санитарных норм',
    ],
    requirements: [
      'Опыт от 1 года',
      'Знание техник приготовления роллов',
      'Аккуратность и скорость',
    ],
  },
  {
    id: 'sous-chef',
    title: 'Су-Шеф',
    salary: 'от 4 500₽ до 5 500₽ смена',
    schedule: '5/2, 6/1, 2/2',
    type: 'Полная занятость',
    image: `${CDN}/vacansii%20/shef.webp`,
    duties: [
      'Организация работы кухни',
      'Контроль качества блюд',
      'Обучение персонала',
    ],
    requirements: [
      'Опыт от 1.5 лет',
      'Знание санитарных норм',
      'Лидерские качества',
    ],
  },
  {
    id: 'packer',
    title: 'Комплектовщик заказов',
    salary: 'от 2 200₽ до 3 000₽ смена',
    schedule: '2/2',
    type: 'Полная занятость',
    image: `${CDN}/vacansii%20/komplektovshik.webp`,
    duties: [
      'Сбор заказов по накладным',
      'Проверка комплектности',
      'Помощь в административной работе',
    ],
    requirements: [
      'Внимательность к деталям',
      'Физическая выносливость',
      'Без опыта — обучим',
    ],
  },
  {
    id: 'courier',
    title: 'Водитель-курьер со своим авто',
    salary: 'от 5 000₽ до 8 000₽ смена',
    schedule: 'Гибкий график',
    type: 'Свободная занятость',
    image: `${CDN}/vacansii%20/voditel.webp`,
    duties: [
      'Доставка заказов клиентам',
      'Работа с приложением для курьеров',
      'Соблюдение стандартов качества доставки',
    ],
    requirements: [
      'Наличие личного автомобиля',
      'Знание города',
      'Без опыта — обучим',
    ],
  },
];

export const PERKS: Perk[] = [
  { icon: CashIcon, title: 'Стабильная зарплата', desc: 'Выплаты 2 раза в месяц без задержек' },
  { icon: CalendarIcon, title: 'Гибкий график', desc: 'Подберём удобное расписание' },
  { icon: GraduationCapIcon, title: 'Обучение', desc: 'Бесплатное наставничество с первого дня' },
  { icon: TrendUpIcon, title: 'Карьерный рост', desc: 'Возможность вырасти до управляющего' },
  { icon: CutleryIcon, title: 'Питание', desc: 'Бесплатное питание на смене' },
  { icon: HandHeartIcon, title: 'Коллектив', desc: 'Дружная молодая команда' },
  { icon: IdCardIcon, title: 'Оформление', desc: 'Официальное трудоустройство' },
];

export const CONTACT = {
  max: { url: 'https://max.ru/u/f9LHodD0cOJy8oPBxUr-x-mis-JgEXUn4KSVirJM9Ix_OdGwXP4A3anpCCU', label: 'Откликнуться в Max' },
  phone: { url: 'tel:+78633335050', label: '+7 (863) 333-50-50' },
  city: 'Ростов-на-Дону',
};
